module.exports = __webpack_public_path__ + "2e7b93b0066c51f046b3d73dcafb1df7.pdf";